import $api from "@/core/services/ApiService";
import { AxiosRequestConfig, AxiosResponse } from "axios";

class CompanyEndpoint {
  public list(params: AxiosRequestConfig = {}): Promise<AxiosResponse> {
    return $api.get("a/companies", params);
  }

  public profile(
    company_id: string,
    params: AxiosRequestConfig = {}
  ): Promise<AxiosResponse> {
    return $api.get(`a/companies/${company_id}`, params);
  }

  public viewByZohoId(
    zoho_id: string,
    params: AxiosRequestConfig = {}
  ): Promise<AxiosResponse> {
    return $api.get(`a/companies/view-by-zoho-id/${zoho_id}`, params);
  }

  public compliances(
    company_id: string,
    params: AxiosRequestConfig = {}
  ): Promise<AxiosResponse> {
    return $api.get(`a/companies/${company_id}/compliances`, params);
  }

  public employees(
    company_id: string,
    params: AxiosRequestConfig = {}
  ): Promise<AxiosResponse> {
    return $api.get(`a/companies/${company_id}/employees`, params);
  }

  public update(
    company_id: number | string,
    params: AxiosRequestConfig = {}
  ): Promise<AxiosResponse> {
    return $api.put(`a/companies/${company_id}`, params);
  }

  public updateEmployee(
    company_id: number | string,
    employee_id: number | string,
    params: AxiosRequestConfig = {}
  ): Promise<AxiosResponse> {
    return $api.put(
      `a/companies/${company_id}/employees/${employee_id}`,
      params
    );
  }

  public employeeCompliances(
    company_id: number | string,
    employee_id: number | string,
    params: AxiosRequestConfig = {}
  ): Promise<AxiosResponse> {
    return $api.get(
      `a/companies/${company_id}/employees/${employee_id}/compliances`,
      params
    );
  }

  public paymentServices(
    company_id: string,
    params: AxiosRequestConfig = {}
  ): Promise<AxiosResponse> {
    return $api.get(`a/companies/${company_id}/payment-services`, params);
  }

  public onboardingTransitions(
    company_id: string,
    payment_service: string,
    params: AxiosRequestConfig = {}
  ): Promise<AxiosResponse> {
    return $api.get(
      `a/companies/${company_id}/payment-services/${payment_service}/onboarding-transitions`,
      params
    );
  }

  public updateOnboardingTransitionFields(
    company_id: string,
    payment_service: string,
    transition_id: string,
    params: AxiosRequestConfig = {}
  ): Promise<AxiosResponse> {
    return $api.put(
      `a/companies/${company_id}/payment-services/${payment_service}/onboarding-transitions/${transition_id}/fields`,
      params
    );
  }

  public applyNextOnboardingTransition(
    company_id: string,
    payment_service: string,
    next_stage: string,
    params: AxiosRequestConfig = {}
  ): Promise<AxiosResponse> {
    return $api.post(
      `a/companies/${company_id}/payment-services/${payment_service}/onboarding-transitions/${next_stage}`,
      params
    );
  }

  public startOnboarding(
    company_id: string,
    payment_service: string,
    params: AxiosRequestConfig = {}
  ): Promise<AxiosResponse> {
    return $api.post(
      `a/companies/${company_id}/payment-services/${payment_service}/onboard`,
      params
    );
  }
}

export default CompanyEndpoint;
